import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { HelpModalComponent } from '../help-modal/help-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TicketApiService } from 'src/app/services/api/ticket-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-support3-panel',
  templateUrl: './support3-panel.component.html',
  styleUrls: ['./support3-panel.component.scss'],
})
export class Support3PanelComponent {
  @Input() platformInfo: any;
  @Input() problemInfo: any;
  @Output() back = new EventEmitter<any>();
  @Output() next = new EventEmitter<any>();
  index = 0;
  input: any = '';
  image: any;
  imageUrl: any = '';
  errorInput = false;
  errorImage = false;

  constructor(
    private api: UserApiService,
    private dialog: MatDialog,
    private apiTicket: TicketApiService,
    private message: MessageService,
  ) {}

  data = [
    {
      id: 0,
      key: 'help',
      txt1: '帮助中心',
      txt2: '查看常见问题步骤',
      txt3: '?',
    },
    {
      id: 1,
      key: 'ai',
      txt1: 'AI 客服',
      txt2: '先确认是否需要售后',
      txt3: 'AI',
    },
    {
      id: 2,
      key: 'ticket',
      txt1: '提交工单',
      txt2: '无需对话，直接核验处理',
      txt3: '↗',
    },
  ];

  selectTab(info: any) {
    this.index = info.id;
    if (info.key === 'help') this.openHelp();
    if (info.key === 'ai') this.openAiCustomerService();
  }

  list1: any = [
    { txt: '所有设备都出现' },
    { txt: '仅电视出现' },
    { txt: '今天刚发生' },
    { txt: '已经重试过' },
  ];

  addWord(text: string) {
    this.input = this.input + text;
  }

  backStep() {
    this.back.emit(2);
  }

  onFileChange(e: any) {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    this.image = files[0];
    this.uploadFile(this.image);
  }

  loading = false;
  async uploadFile(file: any) {
    try {
      const r = await this.api.postQiniu(file);
      this.imageUrl = r.url;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  submit() {
    if (this.input === '' || this.imageUrl === '') {
      if (this.input === '') {
        this.errorInput = true;
      }
      if (this.imageUrl === '') {
        this.errorImage = true;
      }
      return;
    }

    this.postProblemTicket(this.input, this.imageUrl);
  }

  openHelp() {
    this.dialog.open(HelpModalComponent, {
      data: Object.assign(
        {},
        { problemInfo: this.problemInfo, platformInfo: this.platformInfo },
      ),
      width: '480px',
      panelClass: 'app-dialog',
    });
  }

  openAiCustomerService() {
    this.getDingdingData();
  }

  async getDingdingData() {
    try {
      const r = await this.api.getDingdingData();
      const dingding_url = r.data.access_url;
      window.open(dingding_url);
    } catch (error) {}
  }

  get getTime() {
    return (time: number) => {
      if (time > 0) return `${time} 分钟内`;
      if (time === 0) return '立即';
      return '';
    };
  }

  isVisible(key: string): boolean {
    const map: any = {
      ai: this.problemInfo.enable_ai,
      help: this.problemInfo.enable_help,
      ticket: this.problemInfo.enable_ticket,
    };

    return !!map[key];
  }

  async postProblemTicket(description: string, screenshot_url: string) {
    try {
      this.loading = true;
      const r = await this.apiTicket.postProblemTicket(
        this.problemInfo.id,
        this.platformInfo.bus_seat_id,
        this.platformInfo.order.order_id,
        this.platformInfo.platform_id,
        description,
        screenshot_url,
      );
      if (r.status === 0) {
        this.next.emit(r.data.ticket);
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
